const data = [
  {
    question: "Where do I get my sim card?",
    answer:
      "Once you have successfully Registered for FLP Connect, you will either:<br> Receive your sim card immediately if you have registered at one of our outlets or;<br> Receive an SMS with your registration code to collect your sim card at any Clicks store nationwide",
  },
  {
    question: "How do I activate my sim card?",
    answer:
      'We do the activation for you.<br> Pop your SIM into your device and switch it on, wait for your phone to display a signal.<br> If your SIM card is still not active or showing a signal, give us call at <a href="tel:087 357 7777">087 357 7777</a>.',
  },
  {
    question: "When is my airtime loaded?",
    answer:
      "On the 1st of each month your account will be recharged with an additional R249.00 worth of airtime provided your monthly premium has been paid. We will also send you an SMS to let you know that your FREE Airtime has been loaded to your SIM card.<br> There are no restrictions on what you can use your free airtime on, for example making calls, surfing the internet, WhatsApp, etc...",
  },
  {
    question: "How long is my airtime valid for?",
    answer:
      "All Free airtime is valid for 30 days from the day it was loaded<br> Any additional airtime purchased is valid for 90 days from the day it was loaded",
  },
  {
    question: "I have the standard FLP membership - Can I upgrade?",
    answer:
      "Yes you can upgrade to FLP Connect at anytime, plus you wont need to pay any joining fees. Simply sign up for UConnect here.",
  },
  {
    question: "How do I check my airtime balance?",
    answer:
      "1. Download The UConnect App from Google Play, Huawei or the Apple App Store.<br><br> OR <br><br>Dial *101# from your SIM card and it'll display all available balances. (Purchase Airtime, Free Airtime and Data)",
  },
  {
    question: "How do I purchase and load airtime?",
    answer:
      "1. Download The UConnect App from Google Play, Huawei or the Apple App Store.<br><br> OR<br><br> 2. Go to any Airtime vendor and purchase a standard Cell C Airtime voucher. To load the Airtime voucher, dial *102*Voucher number# <br><br>OR <br><br>3. Use your online banking to purchase Cell C Airtime",
  },
  {
    question: "Can I get my free monthly airtime onto my primary number?",
    answer:
      'If your primary number is a prepaid number, you can give us a call <a href="tel:087 357 7777">087 357 7777</a> and we\'ll port your number onto a UConnect SIM card. Once this is done, then your FREE Airtime will be loaded onto your primary number.',
  },
  {
    question: "Can I port my number to the UConnect sim card?",
    answer:
      'Yes. You can either dial 135 from your SIM card (free call) or <a href="tel:087 357 7777">087 357 7777</a> and we will initiate the port for you.',
  },
  {
    question: "Can I make international calls?",
    answer:
      "You can't use your FREE Airtime to make international calls. You can make international calls with your purchased airtime. International rates apply.",
  },
  {
    question: "Can I use my sim card outside of South Africa?",
    answer:
      "Unfortunately not. The feature isn't available on our SIM cards yet.",
  },
  {
    question: "Can I use my sim card in a modem or mobile data device?",
    answer:
      'Yes. We suggest you give us a call at <a href="tel:087 357 7777">087 357 7777</a>, to get another SIM card for FREE and then use The UConnect App to purchase and load Data onto that SIM card.',
  },
  {
    question: "How can I stop my airtime being used up by data?",
    answer:
      "To stop your Airtime being used for Data, dial *147# and go through the option to “Stop using Airtime for Data”.<br><br> In addition, if you haven't requested to Stop using Airtime for Data from the *147# USSD menu, please turn off automatic updates over mobile Data connections - Select using Wi-Fi for updating Apps and software.",
  },
  {
    question: "What are the most important numbers to know?",
    answer:
      "To get the most out of your SIM, please note the following important numbers<br><br><ul><li>135 - Cellular support</li><li>*147# - Self-service</li><li>132 - Set up and listen to your voicemail</li><li>*133*1# - Block premium rated SMS services</li><li>*101# - Balance enquiries</li><li>*102*voucher number# - Load airtime vouchers</li></ul>",
  },
  {
    question: "What can I do if I've lost my sim card or phone?",
    answer:
      "Call us immediately at <a href=\"tel:087 357 7777\">087 357 7777</a> and we'll block your lost SIM to prevent you from losing any Airtime or Data. We'll also initiate a new SIM request. You can pick up your new SIM at any Clicks store nationwide.",
  },
  {
    question: "What is my mobile number?",
    answer:
      "Simply dial *147# from your SIM card and choose option 4 for self-service.",
  },
  {
    question: "What will cause my sim card to be deactivated?",
    answer:
      "If we see no usage on your SIM Card for 90 days, we'll deactivate it. Your SIM card will remain active if it's being used. No usage means that you haven't made or received any calls or used any Data.<br><br>If your SIM card is deactivated, call <a href=\"tel:087 357 7777\">087 357 7777</a> as soon as possible and request another SIM card. A new number will be allocated to you. Simply keep connecting to stay connected.",
  },
  {
    question: "How do I download the UConnect app?",
    answer:
      'Click one of the Links below to get the UConnect App -<br>Google- <a href="https://play.google.com/store/apps/details?id=za.co.digitlab.unlimitedconnect&hl=en_ZA">https://play.google.com/store/apps/details?id=za.co.digitlab.unlimitedconnect&hl=en_ZA</a> <br>Huawei- <a href="https://appgallery.huawei.com/#/app/C102534757?locale=en_US&source=appshare&subsource=C102534757">https://appgallery.huawei.com/#/app/C102534757?locale=en_US&source=appshare&subsource=C102534757</a><br>IOS- <a href="https://apps.apple.com/za/app/the-unlimited-double-connect/id1372716767">https://apps.apple.com/za/app/the-unlimited-double-connect/id1372716767</a><br>',
  },
  {
    question: "What happens to my airtime if I don't activate my sim card?",
    answer:
      "Should you not have an active sim card, your monthly airtime recharge will be SMSed to you in the form of a USSD Airtime Voucher. On activation of your sim card you can load the voucher. All vouchers are valid for 30 days from loading.",
  },
  {
    question: "Need more help?",
    answer:
      "Having issues or can't find the answer that you're looking for? Contact UConnect on <a href=\"tel:086 101 0003\">0861010003</a>.",
  },
];

export default data;
